import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
 

   
<svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 36 36"
      fill="none"
      aria-hidden="true"
    >
      <defs>
        <clipPath id={`expand-circle-left-clip`}>
          <rect x="8" y="8" width="20" height="20" />
        </clipPath>
      </defs>

      <rect width="36" height="36" rx="18" fill="#F5F5F5" />
      <g clipPath={`url(#expand-circle-left-clip)`}>
        <path
          d="M14.52 18.833L19.1867 23.4997L17.9992 24.6663L11.3325 17.9997L17.9992 11.333L19.1867 12.4997L14.52 17.1663H24.6659V18.833H14.52Z"
          fill="currentColor"
        />
      </g>
    </svg>


);

export default Icon;
